<template>
  <div class="techerDivDisplay" v-if="items.length > 0">
    <title-widge :title="title" :subTitle="subTitle"></title-widge>
    <div>
      <common-techer-display-widge :imgs="items" class="teacher_desc">
      </common-techer-display-widge>
    </div>
  </div>
</template>

<script>
import titleWidge from "./titleWidge";
import commonTecherDisplayWidge from "../../common/components/techerDisplayWidge";
export default {
  components: {
    titleWidge,
    commonTecherDisplayWidge,
  },
  props: {
    title: {
      type: String,
      default: "",
    },
    subTitle: {
      type: String,
      default: "",
    },
    items: {
      type: Array,
      default: function() {
        return [];
      },
    },
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
@import "../scss/teacherDisplayWidge.scss";
</style>
